import { Component, Injector, OnInit } from '@angular/core';
import { FormSettings } from '../../forms/form-settings';
import { FormComponent } from '../../forms/form.component';

@Component({
  selector: 'app-data-importer-form',
  templateUrl: './data-importer-form.component.html',
  styleUrls: ['./data-importer-form.component.scss']
})
export class DataImporterFormComponent extends FormComponent {

  private _reloadedItem: any;

  constructor(protected _injector: Injector) { 
    super(_injector);
  }

  async ngOnInit() {
    await super.init()
  }

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        file: { required: true },
        headerPresent: {
          selectableOptions: [
            { id: 'Y', label: 'Yes' },
            { id: 'N', label: 'No' }
          ]
        },
        separator: {
          selectableOptions: [
            { id: 'comma', label: 'Comma' },
            { id: 'semicolon', label: 'Semicolon' }
          ]
        }
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[] }> {
    this._reloadedItem = {}

    return this._toForm(this._reloadedItem);
  }
  
  /** @override */
  protected async _submitHook() {
    
  }

  private  _toForm = (dto: any): { [key: string]: number | string | boolean | (string | number)[] | File | File[] } => {
    let result: { [key: string]: number | string | boolean | (string | number)[] | File | File[] } = {}
    result.firstName = dto.firstName;
    return result;
  }
}

